import { motion } from "framer-motion";

import SectionHead from "./SectionHead";
import { team } from "../data/team";
import { revealContainer, fadeUp } from "../lib/motionVariants";

export default function Studio() {
  return (
    <motion.section
      id="studio"
      variants={revealContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      className="pb-7 pt-10 md:pb-12 md:pt-20"
    >
      <motion.div variants={fadeUp}>
        <SectionHead num="04" title="WHO BUILDS IT" meta="Two type designers, two engineers" />
      </motion.div>

      <div className="grid grid-cols-1 gap-5 pt-6 sm:grid-cols-2 lg:grid-cols-4 md:gap-9 md:pt-10">
        {team.map((m) => (
          <motion.article key={m.name} variants={fadeUp} className="group">
            <div className="border border-ink bg-surface p-1.5 transition-colors duration-200 group-hover:border-primary">
              <img
                src={require(`../images/${m.src}`)}
                alt={m.alt}
                loading="lazy"
                decoding="async"
                className="block aspect-[4/5] w-full object-cover grayscale contrast-[1.05] transition-[filter] duration-300 group-hover:grayscale-0"
              />
            </div>
            <h3 className="mt-3.5 text-[19px] font-medium">{m.name}</h3>
            <p className="mt-1.5 font-mono text-[10.5px] uppercase tracking-[0.14em] text-primary">{m.role}</p>
            <p className="mt-2.5 text-[15px] leading-normal text-ink-500">{m.desc}</p>
          </motion.article>
        ))}
      </div>

      <motion.p
        variants={fadeUp}
        className="mt-7 max-w-[60ch] border-t border-border pt-6 text-[clamp(18px,1.8vw,24px)] leading-snug md:mt-12"
      >
        Born in Uruguay, five years in the making, and still shaped in conversation with the foundries
        running on it. Type design deserves more than distribution: it deserves presentation, tools and
        long-term reliability.
      </motion.p>
    </motion.section>
  );
}
